import * as React from "react";
import { Row, Col } from "antd";
import styled from "styled-components";
import { EntryComponentContainer } from "../../../shared/EntryComponentContainer";
import { BookPoint } from "../model/BookMultiOrder";
import TimeWindowPicker from "../../../shared/TimeWindowPicker";
import { AddressInput } from "../../addresses/components/AddressInput";

const EntryHeadline = styled.span`
  color: #061a32;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
`;

type Props = {
  title: string;
  inputTitle: string;
  point: BookPoint;
  onChange: (value: BookPoint) => void;
};

export class SinglePointComponent extends React.Component<Props> {
  render() {
    const { title, point, onChange } = this.props;
    return (
      <Row type="flex" justify="center">
        <Col span={11} md={11} xs={24}>
          <EntryComponentContainer>
            <Row type="flex" justify="center">
              <Col span={24}>
                <EntryHeadline>{title}</EntryHeadline>
                <AddressInput
                  title={this.props.inputTitle}
                  value={point.address}
                  onChange={value =>
                    onChange({
                      ...point,
                      address: value
                    })
                  }
                />
                <div style={{ height: "21px" }} />
                <TimeWindowPicker
                  value={point.timewindow}
                  onChange={value =>
                    onChange({
                      ...point,
                      timewindow: value
                    })
                  }
                />
              </Col>
            </Row>
          </EntryComponentContainer>
        </Col>
      </Row>
    );
  }
}
